import axios from 'axios';

import { SERVER_URL } from '../constants/config';

const instance = axios.create({
    baseURL: SERVER_URL,
    withCredentials: true,
});

instance.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
});

export default instance;